import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";

const LOG_TAG = "SERVICE:CHANNEL";
export const RAINBOW_HUB_CHANNEL_NAME = "Rainbow for Developers";


// Get the channel informations and get if user is subscribe.
export const getInformationChannel = (channelId) => {
    LogService.trace(LOG_TAG, "getInformationChannel", "enter");

    return RainbowServerFetch.get(`/api/rainbow/channels/v1.0/channels/${channelId}`)
        .then(response => {
            LogService.info(LOG_TAG, "getInformationChannel", "successfully to get information channel");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getInformationChannel", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}

// Get the items from channel.
export const getItemsFromChannel = (channelId) => {
    LogService.trace(LOG_TAG, "getItemsFromChannel", "enter");

    return RainbowServerFetch.get(`/api/rainbow/channels/v1.0/channels/${channelId}/items`)
        .then(response => {
            LogService.info(LOG_TAG, "getItemsFromChannel", "successfully to get items from channel");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getItemsFromChannel", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}

// Get the owner
export const getCreatorChannel = (channelId) => {
    LogService.trace(LOG_TAG, "getCreatorChannel", "enter");

    let queryParameters = "?format=small&types=owner";

    return RainbowServerFetch.get(`/api/rainbow/channels/v1.0/channels/${channelId}/users${queryParameters}`)
        .then(response => {
            LogService.info(LOG_TAG, "getCreatorChannel", "successfully to find the channel");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getCreatorChannel", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}

// Subscribe to the Hub Channel.
export const subscribeChannel = (channelId) => {
    LogService.trace(LOG_TAG, "subscribeChannel", "enter");

    return RainbowServerFetch.post(`/api/rainbow/channels/v1.0/channels/${channelId}/subscribe`)
        .then(response => {
            LogService.info(LOG_TAG, "subscribeChannel", "successfully to subscribe the channel");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "subscribeChannel", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}

// unSubscribe to the Hub Channel.
export const unSubscribeChannel = (channelId) => {
    LogService.trace(LOG_TAG, "unSubscribeChannel", "enter");

    return RainbowServerFetch.delete(`/api/rainbow/channels/v1.0/channels/${channelId}/subscribe`)
        .then(response => {
            LogService.info(LOG_TAG, "unSubscribeChannel", "successfully to unsubscribe the channel");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "unSubscribeChannel", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}

// Find Hub Channel(if exist) and get ChannelID.
export const findChannel = () => {
    LogService.trace(LOG_TAG, "findChannel", "enter");

    const name = RAINBOW_HUB_CHANNEL_NAME;

    return RainbowServerFetch.get("/api/rainbow/channels/v1.0/channels/search?name=" + name)
        .then(response => {
            LogService.info(LOG_TAG, "findChannel", "successfully to find the channel");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "findChannel", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
}